<div class="lpo-dialog-container">
  <div class="calendar-backdrop" *ngIf="activeCalendarRow || showWizardCalendar" (click)="closeCalendar()"></div>
  <!-- Navigation / Action Bar -->
  <div class="lpo-header-actions" [class.page-mode]="!dialogRef" *ngIf="!showInitialChoice && !showUploadSection">
    <div class="nav-branding" *ngIf="!dialogRef">
      <img src="../../../assets/logo-nav.png" alt="Logo" class="main-logo" />
    </div>

    <div class="spacer"></div>
    <!-- <h2 class="navbar-title">Timesheet</h2> -->
    <div class="spacer"></div>



    <button mat-stroked-button color="accent" *ngIf="isCompleted" (click)="downloadPDF()" style="margin-right: 8px">
      <mat-icon>download</mat-icon> Download
    </button>
    <button mat-button *ngIf="uploadedTimesheetUrl" [disabled]="!uploadedTimesheetUrl"
      style="margin-right: 8px; color: #1976d2" onclick="window.open(this.getAttribute('data-url'), '_blank')"
      [attr.data-url]="uploadedTimesheetUrl">
      <mat-icon>visibility</mat-icon> View
    </button>

    <button mat-button (click)="onClose()">Cancel</button>
    <button *ngIf="!isCompleted && canEdit" mat-raised-button color="primary"
      (click)="save(true, rows.length > 0 && !rowsInitiatedBy)" [disabled]="isLoading">
      <mat-icon>{{ rowsInitiatedBy ? "save" : "check_circle" }}</mat-icon>
      {{ rows.length > 0 && !rowsInitiatedBy ? "Start & Send" : "Save Progress" }}
    </button>

    <!-- User Profile Section -->
    <div class="user-profile-section" *ngIf="currentusername">
      <div class="user-info-text">
        <span class="user-name">{{ currentusername }}</span>
        <span class="user-role">{{
          isVendor ? "Vendor" : isCustomer ? "Customer" : "User"
          }}</span>
      </div>
      <div class="avatar-circle">
        <img *ngIf="currentuserImage" [src]="currentuserImage" alt="Avatar" (error)="currentuserImage = null" />
        <span *ngIf="!currentuserImage">
          {{ currentusername.charAt(0) | uppercase }}
        </span>
      </div>
    </div>
  </div>

  <!-- Initial Choice Screen -->
  <div class="initial-choice-container" *ngIf="!isLoading && showInitialChoice">
    <button mat-icon-button (click)="onClose()" style="position: absolute; top: 20px; left: 20px">
      <mat-icon>close</mat-icon>
    </button>

    <h2>Timesheet</h2>
    <p>
      How would you like to provide the timesheet for this booking?
      You can upload your own document or generate one digitally.
    </p>

    <div class="choice-buttons">
      <div class="choice-card" (click)="openUploadSection()">
        <div class="icon-wrapper">
          <mat-icon>upload_file</mat-icon>
        </div>
        <div class="text-wrapper">
          <span>Upload Timesheet</span>
          <small>Upload an existing PDF or image document from your device.</small>
        </div>
      </div>

      <div class="choice-card" (click)="onGenerateClick()">
        <div class="icon-wrapper">
          <mat-icon>edit_note</mat-icon>
        </div>
        <div class="text-wrapper">
          <span>Generate Digital Timesheet</span>
          <small>Create a professional digital timesheet using our smart template.</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload Section -->
  <div class="initial-choice-container" *ngIf="!isLoading && showUploadSection">
    <button mat-icon-button (click)="onBackToChoice()" style="position: absolute; top: 20px; left: 20px">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <h2>Upload Timesheet</h2>
    <p>
      Please select a PDF or image file of your timesheet to attach
      it to this booking.
    </p>

    <div class="upload-area-container">
      <div class="upload-drop-zone" [class.has-file]="selectedFile" (click)="openFilePicker()">
        <div class="upload-icon-circle">
          <mat-icon>{{
            selectedFile ? "description" : "picture_as_pdf"
            }}</mat-icon>
        </div>

        <div class="file-info" *ngIf="selectedFile">
          <span class="file-name">{{ selectedFile.name }}</span>
          <span class="file-size">{{ (selectedFile.size / 1024).toFixed(1) }} KB</span>
        </div>

        <p class="upload-prompt" *ngIf="!selectedFile">
          Drag & drop your file here or <strong>browse</strong>
        </p>

        <input type="file" #fileInput (change)="onFileSelected($event)" accept=".pdf,image/*" hidden />
      </div>

      <div class="upload-actions">
        <button mat-flat-button color="primary" class="confirm-upload-btn" [disabled]="!selectedFile || isSaving"
          (click)="uploadTimesheetFile()">
          <mat-icon *ngIf="!isSaving">cloud_upload</mat-icon>
          <mat-spinner diameter="20" *ngIf="isSaving" style="margin-right: 8px"></mat-spinner>
          {{ isSaving ? "Uploading..." : "Confirm & Upload" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Batch Setup Section -->
  <div class="initial-choice-container" *ngIf="!isLoading && showBatchSetup">
    <button mat-icon-button (click)="onBackToChoice()" style="position: absolute; top: 20px; left: 20px">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="batch-setup-focused">
      <div class="setup-header">
        <div class="icon-circle">
          <mat-icon>auto_awesome</mat-icon>
        </div>
        <h2>Let's Get Started!</h2>
        <p>Automatically fill your timesheet for a standard work week based on your booking dates.</p>
      </div>

      <div class="setup-content-card">
        <!-- Step Indicator -->
        <div class="setup-stepper">
          <div class="step" [class.active]="setupStep >= 1" [class.completed]="setupStep > 1">
            <span class="step-num">1</span>
            <span class="step-label">Dates</span>
          </div>
          <div class="step-line"></div>
          <div class="step" [class.active]="setupStep >= 2" [class.completed]="setupStep > 2">
            <span class="step-num">2</span>
            <span class="step-label">Work Days</span>
          </div>
          <div class="step-line"></div>
          <div class="step" [class.active]="setupStep >= 3" [class.completed]="setupStep > 3">
            <span class="step-num">3</span>
            <span class="step-label">Hours</span>
          </div>
        </div>

        <!-- STEP 1: DATE RANGE -->
        <div class="step-content" *ngIf="setupStep === 1">
          <div class="setup-section">
            <label>Confirm Timesheet Period</label>
            <div class="setup-date-grid">
              <div class="setup-time-item">
                <span class="label">Start Date</span>
                <div class="setup-input-wrapper"
                  [class.calendar-open]="showWizardCalendar && calendarMode === 'batch-start'"
                  (click)="openCalendar($event, 'batch-start')">
                  <mat-icon class="input-icon">calendar_today</mat-icon>
                  <span class="time-val">{{ batchStartDate | date: 'dd MMM yyyy' }}</span>

                  <div class="calendar-dropdown" *ngIf="showWizardCalendar && calendarMode === 'batch-start'"
                    (click)="$event.stopPropagation()">
                    <div class="calendar-header">
                      <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                      <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                      <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                    </div>
                    <div class="calendar-weekdays">
                      <span *ngFor="let d of weekdays">{{ d }}</span>
                    </div>
                    <div class="calendar-grid">
                      <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                        [class.is-today]="day.isToday" [class.is-past]="day.isPast" (click)="selectDay(day)">
                        {{ day.date }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="setup-time-item">
                <span class="label">End Date</span>
                <div class="setup-input-wrapper"
                  [class.calendar-open]="showWizardCalendar && calendarMode === 'batch-end'"
                  (click)="openCalendar($event, 'batch-end')">
                  <mat-icon class="input-icon">event</mat-icon>
                  <span class="time-val">{{ batchEndDate | date: 'dd MMM yyyy' }}</span>

                  <div class="calendar-dropdown" *ngIf="showWizardCalendar && calendarMode === 'batch-end'"
                    (click)="$event.stopPropagation()">
                    <div class="calendar-header">
                      <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                      <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                      <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                    </div>
                    <div class="calendar-weekdays">
                      <span *ngFor="let d of weekdays">{{ d }}</span>
                    </div>
                    <div class="calendar-grid">
                      <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                        [class.is-today]="day.isToday" [class.is-past]="day.isPast" (click)="selectDay(day)">
                        {{ day.date }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="step-hint">Original Booking: {{ minDate | date:'shortDate' }} - {{ maxDate | date:'shortDate' }}
            </p>
          </div>
        </div>

        <!-- STEP 2: WORK DAYS & OFF DAYS -->
        <div class="step-content" *ngIf="setupStep === 2">
          <div class="setup-section">
            <label>Select Your Working Days</label>
            <div class="days-grid">
              <button mat-button class="setup-day-btn" *ngFor="let day of weekdays; let i = index"
                (click)="weekdaysSelection[i] = !weekdaysSelection[i]" [class.active]="weekdaysSelection[i]">
                {{ day }}
              </button>
            </div>
          </div>

          <div class="setup-section" style="margin-top: 32px;">
            <label>Are there any days off?</label>
            <p class="section-sublabel">Add specific dates within the period that were non-working.</p>
            <div class="off-days-input-group">
              <div class="setup-input-wrapper off-date-picker"
                [class.calendar-open]="showWizardCalendar && calendarMode === 'off-day'"
                (click)="openCalendar($event, 'off-day')">
                <mat-icon class="input-icon">event_busy</mat-icon>
                <span class="time-val">{{ tempOffDate ? (tempOffDate | date: 'dd MMM yyyy') : 'Pick a date' }}</span>

                <div class="calendar-dropdown" *ngIf="showWizardCalendar && calendarMode === 'off-day'"
                  (click)="$event.stopPropagation()">
                  <div class="calendar-header">
                    <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                    <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                    <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                  </div>
                  <div class="calendar-weekdays">
                    <span *ngFor="let d of weekdays">{{ d }}</span>
                  </div>
                  <div class="calendar-grid">
                    <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                      [class.is-today]="day.isToday" [class.is-past]="day.isPast" (click)="selectDay(day)">
                      {{ day.date }}
                    </span>
                  </div>
                </div>
              </div>
              <button mat-flat-button color="primary" class="add-off-btn" (click)="addOffDate()"
                [disabled]="!tempOffDate">
                <mat-icon>add</mat-icon> Add Off Day
              </button>
            </div>

            <div class="off-days-tags" *ngIf="excludedDates.length > 0">
              <div class="off-tag" *ngFor="let date of excludedDates">
                <mat-icon class="tag-icon">block</mat-icon>
                <span>{{ date | date: 'dd MMM' }}</span>
                <mat-icon class="close-icon" (click)="removeOffDate(date)">close</mat-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 3: WORKING HOURS -->
        <div class="step-content" *ngIf="setupStep === 3">
          <div class="setup-section">
            <label>Standard Working Hours</label>
            <div class="setup-time-grid">
              <div class="setup-time-item">
                <span class="label">Start Time</span>
                <div class="setup-input-wrapper">
                  <input type="time" [(ngModel)]="standardStartTime" />
                  <mat-icon class="input-icon">schedule</mat-icon>
                  <span class="time-val">{{ formatTo12Hr(standardStartTime) }}</span>
                </div>
              </div>
              <div class="setup-time-item">
                <span class="label">End Time</span>
                <div class="setup-input-wrapper">
                  <input type="time" [(ngModel)]="standardEndTime" />
                  <mat-icon class="input-icon">logout</mat-icon>
                  <span class="time-val">{{ formatTo12Hr(standardEndTime) }}</span>
                </div>
              </div>
              <div class="setup-time-item">
                <span class="label">Break (Hrs)</span>
                <div class="setup-input-wrapper">
                  <mat-icon class="input-icon">coffee</mat-icon>
                  <input type="number" [(ngModel)]="standardBreakHours" min="0" step="0.5" class="num-input" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ACTIONS -->
        <div class="setup-actions">
          <div class="step-nav-btns">
            <button mat-stroked-button (click)="prevStep()" class="nav-btn">
              <mat-icon>arrow_back</mat-icon>
              {{ setupStep === 1 ? 'Cancel' : 'Previous' }}
            </button>

            <button mat-flat-button color="primary" (click)="nextStep()" class="nav-btn next" *ngIf="setupStep < 3">
              Continue
              <mat-icon>arrow_forward</mat-icon>
            </button>

            <button mat-flat-button color="primary" (click)="autoFillStandard()" class="nav-btn generate"
              *ngIf="setupStep === 3">
              <mat-icon>done_all</mat-icon>
              Generate Rows
            </button>
          </div>

          <button mat-button class="skip-btn" (click)="showBatchSetup = false" *ngIf="setupStep === 1">
            Or start with an empty timesheet
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- SKELETON LOADING -->
  <div class="lpo-scroll-area" *ngIf="isLoading">
    <div class="lpo-paper">
      <!-- Skeleton Header -->
      <div class="receipt-header" style="border-bottom: 2px solid #e2e8f0">
        <div class="brand-info">
          <div class="skeleton skeleton-circle"></div>
          <div class="v-info" style="margin-top: 15px">
            <div class="skeleton skeleton-text md" style="height: 24px"></div>
            <div class="skeleton skeleton-text" style="height: 14px; width: 200px"></div>
            <div class="skeleton skeleton-text" style="height: 14px; width: 150px"></div>
          </div>
        </div>
      </div>

      <!-- Skeleton Title -->
      <div class="receipt-center-title">
        <div class="skeleton" style="height: 32px; width: 200px; margin: 0 auto"></div>
      </div>

      <!-- Skeleton Body -->
      <div class="receipt-body">
        <div class="section-box">
          <div class="skeleton skeleton-text sm" style="margin-bottom: 15px"></div>
          <div class="skeleton skeleton-text md"></div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-text sm"></div>
        </div>
        <div class="section-box text-right" style="display: flex; flex-direction: column; align-items: flex-end">
          <div class="skeleton skeleton-text sm" style="margin-bottom: 15px"></div>
          <div class="skeleton skeleton-text md"></div>
          <div class="skeleton skeleton-text sm"></div>
        </div>
      </div>

      <!-- Skeleton Table -->
      <div class="bookings-table-container" style="
          box-shadow: none;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 0;
        ">
        <table class="skeleton-table">
          <thead>
            <tr>
              <th *ngFor="let i of [1, 2, 3, 4, 5, 6]">
                <div class="skeleton" style="height: 12px; width: 50px; margin: 10px"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of [1, 2, 3, 4, 5]">
              <td *ngFor="let col of [1, 2, 3, 4, 5, 6]">
                <div class="skeleton skeleton-text" style="height: 16px; margin: 0"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Skeleton Footer -->
      <div class="total-row" style="border: 1px solid #e2e8f0; background: #f8fafc">
        <div class="skeleton" style="height: 30px; width: 150px"></div>
      </div>
    </div>
  </div>

  <div class="error-container" *ngIf="!isLoading && errorState" style="text-align: center; padding: 40px">
    <mat-icon color="warn" style="font-size: 48px; width: 48px; height: 48px">error</mat-icon>
    <h3>Booking Not Found</h3>
    <p>
      We couldn't find the booking details for the provided ID ({{
      data?.bookingId
      }}). Please check the link and try again.
    </p>
    <button mat-raised-button color="primary" (click)="onClose()">
      Go Back
    </button>
  </div>

  <div class="lpo-layout-wrapper"
    *ngIf="!isLoading && !errorState && !showInitialChoice && !showUploadSection && !showBatchSetup">
    <!-- Case 1: Uploaded Timesheet Display -->
    <div *ngIf="uploadedTimesheetUrl" class="uploaded-doc-container"
      style="padding: 20px; flex: 1; overflow-y: auto; background: #f8fafc">
      <div class="detail-header" *ngIf="!dialogRef">
        <div class="header-left">
          <button class="back-btn" (click)="onBack()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <h1>Timesheet: {{ tsNumber }}</h1>
        </div>
      </div>

      <div class="lpo-paper" style="text-align: center; max-width: 900px; margin: 0 auto">
        <div *ngIf="isImage(uploadedTimesheetUrl)" class="image-preview">
          <h3 style="margin-bottom: 24px; color: #1e293b; font-weight: 600">
            Uploaded Timesheet Document
          </h3>
          <img [src]="uploadedTimesheetUrl" alt="Uploaded Timesheet" style="
              max-width: 100%;
              border: 1px solid #e2e8f0;
              border-radius: 12px;
              box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
            " />
        </div>

        <div *ngIf="!isImage(uploadedTimesheetUrl)" class="pdf-preview" style="padding: 60px 40px">
          <div style="
              width: 80px;
              height: 80px;
              background: #fef2f2;
              border-radius: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto 24px;
            ">
            <mat-icon style="font-size: 40px; height: 40px; width: 40px; color: #ef4444">picture_as_pdf</mat-icon>
          </div>
          <h2 style="font-size: 24px; color: #1e293b; margin-bottom: 12px">
            PDF Timesheet Uploaded
          </h2>
          <p style="color: #64748b; margin-bottom: 32px; font-size: 16px">
            A PDF document has been attached as the timesheet for this booking.
          </p>
          <div style="display: flex; gap: 16px; justify-content: center">
            <a [href]="uploadedTimesheetUrl" target="_blank" mat-flat-button color="primary"
              style="padding: 0 32px; height: 48px; border-radius: 10px">
              <mat-icon>visibility</mat-icon> View Document
            </a>
            <button mat-stroked-button (click)="openUploadSection()"
              style="padding: 0 24px; height: 48px; border-radius: 10px">
              <mat-icon>refresh</mat-icon> Replace File
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Case 2: Digital Timesheet (Existing content) - Only show if no uploaded URL or user wants to switch? -->
    <!-- Actually, let's show digital content ONLY if no uploaded URL -->
    <div class="lpo-scroll-area" *ngIf="!uploadedTimesheetUrl">
      <div class="detail-header" *ngIf="!dialogRef">
        <div class="header-left">
          <button class="back-btn" (click)="onBack()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <h1>Timesheet: {{ tsNumber }}</h1>
        </div>
      </div>
      <div class="lpo-paper" id="timesheet-pdf-content">
        <!-- Header: Vendor Info (Issuer) -->
        <div class="receipt-header">
          <div class="brand-info">
            <!-- Vendor Logo -->
            <div class="vendor-logo" *ngIf="vendorDetails?.logoBase64 || vendorDetails?.logoUrl">
              <img [src]="vendorDetails.logoBase64 || vendorDetails.logoUrl" alt="Company Logo" />
            </div>
            <div class="v-info">
              <!-- Vendor Name (From) -->
              <h1>{{ vendorDetails?.companyName || vendorName }}</h1>
              <p>{{ vendorDetails?.address || "Vendor Address" }}</p>
              <p *ngIf="vendorDetails?.phone">
                Phno: {{ vendorDetails.phone }}
              </p>
              <p *ngIf="vendorDetails?.telephone">
                Telephone: {{ vendorDetails.telephone }}
              </p>
              <p>Email: {{ vendorDetails?.email || "N/A" }}</p>
            </div>
          </div>
        </div>

        <!-- Centered Timesheet Heading -->
        <div class="receipt-center-title">
          <h2>TIMESHEET</h2>
        </div>

        <!-- Body: To Customer and Timesheet Info -->
        <div class="receipt-body">
          <!-- To Customer -->
          <div class="section-box">
            <h3>Bill To</h3>
            <div class="placeholder-box">
              <p>
                <strong>{{
                  customerDetails?.companyName || customerName
                  }}</strong>
              </p>
              <p>{{ customerDetails?.address || "Customer Address" }}</p>
              <p *ngIf="customerDetails?.phone">
                <span>Phone:</span> {{ customerDetails.phone }}
              </p>
              <p *ngIf="customerDetails?.email">
                <span>Email:</span> {{ customerDetails.email }}
              </p>
            </div>
          </div>

          <!-- Timesheet Number and Date -->
          <div class="section-box text-right">
            <h3>Details</h3>
            <div class="placeholder-box">
              <p><strong>TS Number:</strong> {{ tsNumber }}</p>
              <p><strong>Date:</strong> {{ today | date: "dd MMM yyyy" }}</p>
            </div>
          </div>
        </div>

        <div class="simple-actions-panel" *ngIf="shouldShowGeneration">
          <h2>Let's Get Started!</h2>
          <p class="subtitle">
            Automatically fill your timesheet for a standard work week.
          </p>

          <div class="date-range-hint" *ngIf="minDate && maxDate">
            Booking Period:
            <strong>{{ minDate | date: "dd MMM yyyy" }}</strong> to
            <strong>{{ maxDate | date: "dd MMM yyyy" }}</strong>
          </div>

          <!-- Work Days Selection -->
          <div class="work-days-section">
            <span class="section-label">Select Work Days:</span>
            <button mat-button class="day-btn" *ngFor="let day of weekdays; let i = index"
              (click)="weekdaysSelection[i] = !weekdaysSelection[i]" [class.active]="weekdaysSelection[i]">
              {{ day }}
            </button>
          </div>

          <!-- Time and Break Hours for Standard Fill -->
          <div class="time-break-grid">
            <div class="time-item">
              <label>Start Time</label>
              <div class="input-container">
                <span class="time-overlay">{{
                  formatTo12Hr(standardStartTime)
                  }}</span>
                <input type="time" class="fake-time-input" [(ngModel)]="standardStartTime" />
              </div>
            </div>

            <div class="time-item">
              <label>End Time</label>
              <div class="input-container">
                <span class="time-overlay">{{
                  formatTo12Hr(standardEndTime)
                  }}</span>
                <input type="time" class="fake-time-input" [(ngModel)]="standardEndTime" />
              </div>
            </div>

            <div class="time-item">
              <label>Break (Hrs)</label>
              <div class="input-container">
                <input type="number" class="break-input" [(ngModel)]="standardBreakHours" min="0" step="0.25" />
              </div>
            </div>
          </div>

          <button mat-raised-button class="main-action-btn" (click)="autoFillStandard()">
            <mat-icon>calendar_today</mat-icon>
            Fill Standard Week ({{ formatTo12Hr(standardStartTime) }} to
            {{ formatTo12Hr(standardEndTime) }})
          </button>

          <!-- <div class="secondary-action">
          <button
            mat-button
            class="custom-entry-btn"
            (click)="showAdvanced = !showAdvanced"
          >
            <mat-icon>{{ showAdvanced ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            {{
              showAdvanced
                ? "Hide custom date entry"
                : "Or use custom date entry"
            }}
          </button>
        </div> -->
        </div>

        <!-- Verification panels removed in favor of unified table dispute marking -->

        <div class="batch-options-panel" *ngIf="
            shouldShowTable && canEdit && showAdvanced && !uploadedTimesheetUrl
          " style="
            margin-bottom: 40px;
            padding: 32px;
            background: #f8fafc;
            border-radius: 20px;
            border: 1px solid var(--border-color);
          ">
          <h4 style="
              margin-top: 0;
              margin-bottom: 20px;
              font-weight: 800;
              color: #475569;
              text-transform: uppercase;
              font-size: 12px;
              letter-spacing: 0.1em;
            ">
            Manual Batch Entry
          </h4>

          <!-- Work Days Selection for Advanced -->
          <div style="
              margin-bottom: 15px;
              display: flex;
              align-items: center;
              gap: 8px;
              flex-wrap: wrap;
            ">
            <span style="font-size: 12px; color: #555; font-weight: 500">Filter Days:</span>
            <button mat-stroked-button *ngFor="let day of weekdays; let i = index"
              (click)="weekdaysSelection[i] = !weekdaysSelection[i]" [style.background]="
                weekdaysSelection[i] ? '#e3f2fd' : 'transparent'
              " [style.color]="weekdaysSelection[i] ? '#1565c0' : '#888'" style="
                min-width: 36px;
                padding: 0 8px;
                height: 28px;
                line-height: 28px;
                font-size: 12px;
                border-radius: 14px;
              ">
              {{ day }}
            </button>
          </div>

          <div style="
              display: flex;
              flex-wrap: wrap;
              gap: 20px;
              align-items: flex-end;
            ">
            <div>
              <label style="
                  display: block;
                  font-size: 12px;
                  margin-bottom: 6px;
                  color: #555;
                  font-weight: 500;
                ">Start Date</label>
              <input type="date" class="refined-input" [(ngModel)]="batchStartDate" [min]="minDate" [max]="maxDate"
                style="
                  background: white;
                  border: 1px solid #ccc;
                  padding: 8px;
                  border-radius: 4px;
                " />
            </div>
            <div>
              <label style="
                  display: block;
                  font-size: 12px;
                  margin-bottom: 6px;
                  color: #555;
                  font-weight: 500;
                ">End Date</label>
              <input type="date" class="refined-input" [(ngModel)]="batchEndDate" [min]="minDate" [max]="maxDate" style="
                  background: white;
                  border: 1px solid #ccc;
                  padding: 8px;
                  border-radius: 4px;
                " />
            </div>
            <div>
              <label style="
                  display: block;
                  font-size: 12px;
                  margin-bottom: 6px;
                  color: #555;
                  font-weight: 500;
                ">Start Time</label>
              <input type="time" class="refined-input" [(ngModel)]="batchStartTime" style="
                  background: white;
                  border: 1px solid #ccc;
                  padding: 8px;
                  border-radius: 4px;
                " />
            </div>
            <div>
              <label style="
                  display: block;
                  font-size: 12px;
                  margin-bottom: 6px;
                  color: #555;
                  font-weight: 500;
                ">End Time</label>
              <input type="time" class="refined-input" [(ngModel)]="batchEndTime" style="
                  background: white;
                  border: 1px solid #ccc;
                  padding: 8px;
                  border-radius: 4px;
                " />
            </div>
            <div>
              <label style="
                  display: block;
                  font-size: 12px;
                  margin-bottom: 6px;
                  color: #555;
                  font-weight: 500;
                ">Break (hrs)</label>
              <input type="number" class="refined-input" [(ngModel)]="batchBreakHours" min="0" step="0.25" style="
                  width: 80px;
                  background: white;
                  border: 1px solid #ccc;
                  padding: 8px;
                  border-radius: 4px;
                " />
            </div>
            <div style="margin-left: auto" *ngIf="canAddRow">
              <button mat-raised-button (click)="generateBatchRows()">
                <mat-icon style="margin-right: 5px">playlist_add</mat-icon> Add
                Rows
              </button>
            </div>
            <div style="margin-left: auto" *ngIf="!canAddRow && rows.length > 0">
              <span style="font-size: 11px; color: #0284c7; font-weight: 600">(All days generated)</span>
            </div>
          </div>
          <p style="
              font-size: 11px;
              color: #666;
              margin-top: 10px;
              margin-bottom: 0;
              font-style: italic;
            ">
            * Existing dates and dates locked by the other party will be
            skipped.
          </p>
        </div>

        <!-- STATUS BANNER - Clean Progress Indicator -->
        <div class="ts-status-banner submitted"
          *ngIf="rowsInitiatedBy && !isCompleted && timesheetStatus === 'submitted'">
          <mat-icon>pending_actions</mat-icon>
          <div class="banner-text">
            <strong *ngIf="isVendor && !customerSignatureUrl">Awaiting Customer Review &amp; Signature</strong>
            <strong *ngIf="isVendor && customerSignatureUrl">Customer Approved &amp; Signed</strong>
            <strong *ngIf="isCustomer && !customerAgreed">Timesheet Ready for Your Review</strong>
            <strong *ngIf="isCustomer && customerAgreed && !customerSignatureUrl">Timesheet Approved</strong>
            <strong *ngIf="isCustomer && customerSignatureUrl">Timesheet Signed</strong>

            <span *ngIf="isVendor && !customerSignatureUrl">The customer must review, agree, and sign the timesheet
              first.</span>
            <span *ngIf="isVendor && customerSignatureUrl">Please sign below to complete the timesheet
              certification.</span>
            <span *ngIf="isCustomer && !customerAgreed">Review all entries. If correct, click <strong>Agree to
                Timesheet</strong> below. Otherwise, suggest corrections on the rows.</span>
            <span *ngIf="isCustomer && customerAgreed && !customerSignatureUrl">Please sign below to approve these
              hours.</span>
            <span *ngIf="isCustomer && customerSignatureUrl">Awaiting vendor certification and signature.</span>
          </div>
        </div>

        <div class="ts-status-banner rejected"
          *ngIf="rowsInitiatedBy && !isCompleted && timesheetStatus === 'rejected'">
          <mat-icon>edit_note</mat-icon>
          <div class="banner-text">
            <strong *ngIf="isVendor">Changes Requested by Customer</strong>
            <strong *ngIf="isCustomer">Change Request Sent — Awaiting Vendor Response</strong>
          </div>
        </div>

        <!-- VENDOR RESPONSE PANEL (when customer has rejected) -->
        <div class="vendor-response-panel" *ngIf="isVendor && timesheetStatus === 'rejected'">
          <div class="vrp-header">
            <h4>Review Customer's Suggestions</h4>
            <p>Accept or keep original for each flagged row, then resubmit or create a new timesheet.</p>
          </div>

          <div class="vrp-disputed-rows-table-wrapper"
            style="overflow-x: auto; border: 1px solid #e2e8f0; border-radius: 8px; margin-bottom: 20px;">
            <table class="financial-table entry-table unified-table excel-style-table"
              style="width: 100%; border-collapse: collapse; margin: 0;">
              <thead>
                <tr style="background: #f8fafc; border-bottom: 1px solid #e2e8f0;">
                  <th
                    style="padding: 12px 16px; font-weight: 700; font-size: 11px; text-transform: uppercase; color: #64748b; letter-spacing: 0.05em; text-align: left;">
                    Date</th>
                  <th
                    style="padding: 12px 16px; font-weight: 700; font-size: 11px; text-transform: uppercase; color: #64748b; letter-spacing: 0.05em; text-align: left;">
                    Original (Vendor)</th>
                  <th
                    style="padding: 12px 16px; font-weight: 700; font-size: 11px; text-transform: uppercase; color: #64748b; letter-spacing: 0.05em; text-align: left;">
                    Suggested (Customer)</th>
                  <th
                    style="padding: 12px 16px; font-weight: 700; font-size: 11px; text-transform: uppercase; color: #64748b; letter-spacing: 0.05em; text-align: right;">
                    Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of rows"
                  [style.background]="row.isDisputed ? '#fff5f5' : (row.status === 'Resolved' ? '#f0f9ff' : '#ffffff')"
                  style="border-bottom: 1px solid #f1f5f9; transition: background 0.12s;">
                  <td style="padding: 14px 16px; font-size: 13px; font-weight: 600; color: #0f172a;">{{ row.date }}</td>
                  <td style="padding: 14px 16px; font-size: 13px; color: #475569;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <span>{{ formatTo12Hr(row.startTime) }} – {{ formatTo12Hr(row.endTime) }}</span>
                      <span
                        style="font-weight: 700; background: #f1f5f9; color: #475569; padding: 2px 6px; border-radius: 4px; font-size: 11px;">{{
                        row.totalHours | number:'1.1-1' }} hrs</span>
                    </div>
                  </td>
                  <td style="padding: 14px 16px; font-size: 13px; color: #1e40af;">
                    <div *ngIf="row.isDisputed || row.status === 'Resolved' || row.status === 'Changed'"
                      style="display: flex; align-items: center; gap: 8px;">
                      <span>{{ formatTo12Hr(row.correctionStartTime || row.startTime) }} – {{
                        formatTo12Hr(row.correctionEndTime || row.endTime) }}</span>
                      <span
                        style="font-weight: 700; background: #bfdbfe; color: #1d4ed8; padding: 2px 6px; border-radius: 4px; font-size: 11px;">{{
                        row.correctionTotalHours || row.totalHours | number:'1.1-1' }} hrs</span>
                    </div>
                    <span *ngIf="!row.isDisputed && row.status !== 'Resolved' && row.status !== 'Changed'"
                      style="color: #94a3b8;">—</span>
                  </td>
                  <td style="padding: 14px 16px; text-align: right; white-space: nowrap;">
                    <div *ngIf="row.isDisputed" style="display: inline-flex; gap: 8px; align-items: center;">
                      <!-- Tick (Accept) Button -->
                      <button type="button" (click)="acceptRowCorrection(row)" title="Accept Correction"
                        style="background: #e6f4ea; color: #137333; border: 1px solid #137333; width: 32px; height: 32px; min-width: 32px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px; padding: 0; cursor: pointer;">
                        <mat-icon
                          style="font-size: 20px; width: 20px; height: 20px; line-height: 20px; margin: 0; display: flex; align-items: center; justify-content: center;">check</mat-icon>
                      </button>
                      <!-- Cross (Keep Original) Button -->
                      <button type="button" (click)="rejectRowCorrection(row)" title="Keep Original"
                        style="background: #fce8e6; color: #c5221f; border: 1px solid #c5221f; width: 32px; height: 32px; min-width: 32px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px; padding: 0; cursor: pointer;">
                        <mat-icon
                          style="font-size: 20px; width: 20px; height: 20px; line-height: 20px; margin: 0; display: flex; align-items: center; justify-content: center;">close</mat-icon>
                      </button>
                    </div>
                    <span *ngIf="!row.isDisputed && row.status === 'Resolved'"
                      style="color: #15803d; font-weight: 700; font-size: 13px; display: inline-flex; align-items: center; gap: 4px;">
                      <mat-icon
                        style="font-size: 16px; width: 16px; height: 16px; color: #15803d; vertical-align: middle;">check_circle</mat-icon>
                      Accepted
                    </span>
                    <span *ngIf="!row.isDisputed && row.status === 'OK'"
                      style="color: #64748b; font-weight: 600; font-size: 13px;">
                      Kept Original
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="vrp-footer-actions"
            style="display: flex; gap: 12px; margin-top: 16px; padding-top: 16px; border-top: 1px solid #e2e8f0;">
            <button mat-flat-button (click)="resubmitTimesheet()"
              style="background: #0ea5e9; color: #fff; font-size: 13px; font-weight: 600; border-radius: 6px; padding: 0 20px; height: 38px; line-height: 38px;">
              Accept &amp; Send to Customer
            </button>
            <button mat-stroked-button (click)="createNewTimesheet()"
              style="border-color: #cbd5e1; color: #475569; background: #fff; font-size: 13px; font-weight: 600; border-radius: 6px; padding: 0 20px; height: 38px; line-height: 38px;">
              Create New Timesheet
            </button>
          </div>
        </div>

        <div class="details-section" *ngIf="shouldShowTable && !(isVendor && timesheetStatus === 'rejected')"
          style="display: flex; flex-direction: column">
          <div class="table-header-row" style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;
            ">
            <h3 style="margin: 0">Timesheet Entries</h3>
            <div class="table-actions" style="display: flex; gap: 8px">
              <button mat-button color="warn" *ngIf="canEdit && rows.length > 0" (click)="clearRows()">
                <mat-icon>delete_sweep</mat-icon> Clear All
              </button>
              <button mat-stroked-button color="accent" *ngIf="false">
                <!-- Hidden/Removed as per user request -->
              </button>
              <button mat-raised-button color="primary" *ngIf="canAddRow" (click)="addRow()">
                <mat-icon>add</mat-icon> Add Day
              </button>
            </div>
          </div>

          <div class="table-container" style="margin-bottom: 24px">
            <table class="financial-table entry-table unified-table">
              <colgroup>
                <col style="width: 130px;">
                <col style="width: 120px;">
                <col style="width: 120px;">
                <col style="width: 100px;"> <!-- break -->
                <col style="width: 90px;"> <!-- total hours -->
                <col *ngIf="!customerAgreed" style="width: 100px;"> <!-- status -->
                <col style="width: 160px;"> <!-- actions -->
              </colgroup>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Break (hrs)</th>
                  <th>Total Hours</th>
                  <th *ngIf="!customerAgreed">Status</th>
                  <th *ngIf="!isSignedView" style="text-align: right;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of rows">
                  <tr [class.row-expanded]="row.isExpanded" [class.row-disputed]="row.isDisputed"
                    [class.row-has-correction]="row.status === 'Changed' || row.status === 'Disputed'">
                    <td class="date-cell">
                      <div class="custom-input-wrapper date-wrapper" [class.calendar-open]="activeCalendarRow === row"
                        style="cursor: pointer; background: #f9fafb" (click)="openCalendar($event, row)">
                        <input type="text" class="refined-input date-input" [value]="row.date" readonly
                          style="cursor: pointer" />

                        <div class="calendar-dropdown" *ngIf="activeCalendarRow === row"
                          (click)="$event.stopPropagation()">
                          <div class="calendar-header">
                            <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                            <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                            <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                          </div>
                          <div class="calendar-weekdays">
                            <span *ngFor="let d of weekdays">{{ d }}</span>
                          </div>
                          <div class="calendar-grid">
                            <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                              [class.is-today]="day.isToday" [class.is-past]="day.isPast" [class.locked]="day.isLocked"
                              (click)="selectDay(day)">
                              {{ day.date }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="custom-input-wrapper time-wrapper" [ngClass]="
                          row.isStartTimeDisputed ||
                          (row.isDisputed &&
                            row.correctionStartTime &&
                            row.correctionStartTime !== row.startTime)
                            ? {
                                'field-disputed': row.status === 'Disputed',
                                'field-changed': row.status === 'Changed',
                                'field-resolved': row.status === 'Resolved',
                              }
                            : {}
                        ">
                        <!-- Correction/Current display -->
                        <div class="fake-time-wrapper val-display">
                          <span class="time-overlay" [class.disabled-overlay]="!canEditRow(row)">{{
                            formatTo12Hr(((row.status === 'Changed' || row.status === 'Disputed') ?
                            row.correctionStartTime : row.startTime) || '') }}</span>
                          <input type="time" class="refined-input fake-time-input"
                            [ngModel]="(row.status === 'Changed' || row.status === 'Disputed') ? row.correctionStartTime : row.startTime"
                            (ngModelChange)="((row.status === 'Changed' || row.status === 'Disputed') ? row.correctionStartTime = $event : row.startTime = $event); calculateHours(row)"
                            (change)="onValueChange(row, 'StartTime', row.startTime)" [disabled]="!canEditRow(row)"
                            (click)="$event.stopPropagation()" />
                        </div>

                        <!-- Original value shown on row hover -->
                        <div class="fake-time-wrapper val-original"
                          *ngIf="row.status === 'Changed' || row.status === 'Disputed'">
                          <span class="time-overlay disabled-overlay">{{ formatTo12Hr(row.startTime || '') }}</span>
                          <input type="time" class="refined-input fake-time-input" [ngModel]="row.startTime" disabled />
                        </div>

                        <mat-icon class="input-icon" *ngIf="canEditRow(row)">access_time</mat-icon>
                      </div>
                    </td>
                    <td>
                      <div class="custom-input-wrapper time-wrapper" [ngClass]="
                          row.isEndTimeDisputed ||
                          (row.isDisputed &&
                            row.correctionEndTime &&
                            row.correctionEndTime !== row.endTime)
                            ? {
                                'field-disputed': row.status === 'Disputed',
                                'field-changed': row.status === 'Changed',
                                'field-resolved': row.status === 'Resolved',
                              }
                            : {}
                        ">
                        <!-- Correction/Current display -->
                        <div class="fake-time-wrapper val-display">
                          <span class="time-overlay" [class.disabled-overlay]="!canEditRow(row)">{{
                            formatTo12Hr(((row.status === 'Changed' || row.status === 'Disputed') ?
                            row.correctionEndTime : row.endTime) || '') }}</span>
                          <input type="time" class="refined-input fake-time-input"
                            [ngModel]="(row.status === 'Changed' || row.status === 'Disputed') ? row.correctionEndTime : row.endTime"
                            (ngModelChange)="((row.status === 'Changed' || row.status === 'Disputed') ? row.correctionEndTime = $event : row.endTime = $event); calculateHours(row)"
                            (change)="onValueChange(row, 'EndTime', row.endTime)" [disabled]="!canEditRow(row)"
                            (click)="$event.stopPropagation()" />
                        </div>

                        <!-- Original value shown on row hover -->
                        <div class="fake-time-wrapper val-original"
                          *ngIf="row.status === 'Changed' || row.status === 'Disputed'">
                          <span class="time-overlay disabled-overlay">{{ formatTo12Hr(row.endTime || '') }}</span>
                          <input type="time" class="refined-input fake-time-input" [ngModel]="row.endTime" disabled />
                        </div>

                        <mat-icon class="input-icon" *ngIf="canEditRow(row)">access_time</mat-icon>
                      </div>
                    </td>
                    <td>
                      <div class="custom-input-wrapper no-icon number-wrapper" [ngClass]="
                          row.isBreakDisputed ||
                          (row.isDisputed &&
                            row.correctionBreakHours !== undefined &&
                            row.correctionBreakHours !== row.breakHours)
                            ? {
                                'field-disputed': row.status === 'Disputed',
                                'field-changed': row.status === 'Changed',
                                'field-resolved': row.status === 'Resolved',
                              }
                            : {}
                        ">
                        <div class="val-display" style="width: 100%;">
                          <input type="number" class="refined-input"
                            [ngModel]="(row.status === 'Changed' || row.status === 'Disputed') ? row.correctionBreakHours : row.breakHours"
                            (ngModelChange)="((row.status === 'Changed' || row.status === 'Disputed') ? row.correctionBreakHours = $event : row.breakHours = $event); calculateHours(row)"
                            (change)="onValueChange(row, 'BreakHours', row.breakHours)" min="0" step="0.25"
                            [disabled]="!canEditRow(row)" (click)="$event.stopPropagation()" />
                        </div>

                        <!-- Original value shown on row hover -->
                        <div class="val-original" *ngIf="row.status === 'Changed' || row.status === 'Disputed'"
                          style="width: 100%;">
                          <input type="number" class="refined-input" [ngModel]="row.breakHours" disabled />
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="total-hours-text val-display">{{
                        ((row.status === 'Changed' || row.status === 'Disputed') ? row.correctionTotalHours :
                        row.totalHours) | number: "1.2-2"
                        }}</span>
                      <span class="total-hours-text val-original"
                        *ngIf="row.status === 'Changed' || row.status === 'Disputed'">{{
                        row.totalHours | number: "1.2-2"
                        }}</span>
                    </td>
                    <td *ngIf="!customerAgreed">
                      <div class="status-cell">
                        <span class="status-indicator" [ngClass]="row.status?.toLowerCase() || 'ok'">
                          {{ row.status === 'Disputed' ? 'Edited' : (row.status || "OK") }}
                        </span>
                      </div>
                    </td>
                    <td *ngIf="!isSignedView" style="min-width: 160px; text-align: right; white-space: nowrap;">
                      <div style="display: flex; align-items: center; justify-content: flex-end;">
                        <button *ngIf="isCustomer && timesheetStatus === 'submitted' && !isCompleted && !customerAgreed"
                          (click)="toggleDispute(row); $event.stopPropagation()" style="
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            height: 28px;
                            padding: 0 10px;
                            font-size: 11px;
                            font-weight: 600;
                            font-family: inherit;
                            border: 1.5px solid #3b82f6;
                            border-radius: 5px;
                            background: transparent;
                            color: #3b82f6;
                            cursor: pointer;
                            white-space: nowrap;
                            letter-spacing: 0.01em;
                            transition: background 0.15s, color 0.15s;
                          " onmouseenter="this.style.background='#eff6ff'"
                          onmouseleave="this.style.background='transparent'">
                          <mat-icon style="font-size: 14px; width: 14px; height: 14px; line-height: 14px;">{{
                            row.isDisputed ? 'undo' : 'edit_note' }}</mat-icon>
                          {{ row.isDisputed ? 'Undo' : 'Suggest Correction' }}
                        </button>
                      </div>
                    </td>
                  </tr>

                  <!-- Customer Inline Suggestion Card -->
                  <tr *ngIf="isCustomer && timesheetStatus === 'submitted' && row.isDisputed && !isCompleted"
                    class="suggestion-card-row">
                    <td [attr.colspan]="customerAgreed ? 5 : 6" class="suggestion-card-cell">
                      <div class="suggestion-card">
                        <div class="sc-header">
                          <mat-icon>edit_note</mat-icon>
                          <strong>Your Correction for {{ row.date }}</strong>
                          <button mat-icon-button class="sc-close" (click)="toggleDispute(row)"
                            title="Remove suggestion">
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                        <div class="sc-fields">
                          <div class="sc-field">
                            <label>Start Time</label>
                            <div class="custom-input-wrapper time-wrapper" style="width: 130px;">
                              <div class="fake-time-wrapper">
                                <span class="time-overlay">{{ formatTo12Hr(row.correctionStartTime || row.startTime)
                                  }}</span>
                                <input type="time" class="refined-input fake-time-input"
                                  [(ngModel)]="row.correctionStartTime" (change)="calculateHours(row)"
                                  (click)="$event.stopPropagation()" />
                              </div>
                              <mat-icon class="input-icon">access_time</mat-icon>
                            </div>
                          </div>
                          <div class="sc-field">
                            <label>End Time</label>
                            <div class="custom-input-wrapper time-wrapper" style="width: 130px;">
                              <div class="fake-time-wrapper">
                                <span class="time-overlay">{{ formatTo12Hr(row.correctionEndTime || row.endTime)
                                  }}</span>
                                <input type="time" class="refined-input fake-time-input"
                                  [(ngModel)]="row.correctionEndTime" (change)="calculateHours(row)"
                                  (click)="$event.stopPropagation()" />
                              </div>
                              <mat-icon class="input-icon">access_time</mat-icon>
                            </div>
                          </div>
                          <div class="sc-field">
                            <label>Break (hrs)</label>
                            <div class="custom-input-wrapper no-icon number-wrapper"
                              style="width: 90px; height: 36px; padding: 0 10px;">
                              <input type="number" class="refined-input" [(ngModel)]="row.correctionBreakHours"
                                (change)="calculateHours(row)" min="0" step="0.25" (click)="$event.stopPropagation()"
                                style="width: 100%;" />
                            </div>
                          </div>
                          <div class="sc-field corrected-total" style="justify-content: center; margin-left: 10px;">
                            <label>Corrected Total</label>
                            <strong>{{ row.correctionTotalHours | number:'1.1-1' }} hrs</strong>
                          </div>
                        </div>
                        <div class="sc-comment" style="margin-top: 14px; display: flex; align-items: center;">
                          <mat-icon>chat_bubble_outline</mat-icon>
                          <select class="refined-select" [(ngModel)]="row.disputeReason"
                            style="flex: 1; border: 1.5px solid #cbd5e1; border-radius: 6px; padding: 8px 12px; font-size: 13px; font-family: inherit; background: #fff; cursor: pointer; outline: none; margin-left: 8px;">
                            <option value="">-- Select Reason for Correction --</option>
                            <option value="Working hours incorrect">Working hours incorrect</option>
                            <option value="Break hours incorrect">Break hours incorrect</option>
                            <option value="Overtime not recorded">Overtime not recorded</option>
                            <option value="Operator did not work">Operator did not work</option>
                            <option value="Public holiday rate mismatch">Public holiday rate mismatch</option>
                            <option value="Other correction needed">Other correction needed</option>
                          </select>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>

                <tr *ngIf="rows.length === 0">
                  <td colspan="7" style="
                      text-align: center;
                      padding: 32px;
                      color: #888;
                      font-style: italic;
                      ">
                    <mat-icon style="
                        font-size: 48px;
                        width: 48px;
                        height: 48px;
                        opacity: 0.2;
                        display: block;
                        margin: 0 auto 12px;
                      ">event_busy</mat-icon>
                    No entries found. Click "Add Day" or use Auto-fill to begin.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Customer Action Bar (shown when status=submitted and has corrections suggested) -->
          <div class="customer-action-bar"
            *ngIf="isCustomer && timesheetStatus === 'submitted' && !isCompleted && rows.length > 0 && hasDisputedRows"
            style="display: flex; justify-content: flex-end; padding: 16px 20px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; margin-bottom: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); align-items: center; gap: 16px;">
            <span
              style="font-size: 13px; color: #1e40af; font-weight: 500; display: flex; align-items: center; gap: 6px; flex-grow: 1;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">info</mat-icon>
              Please send the corrections to the vendor for review.
            </span>
            <button mat-flat-button color="primary" (click)="sendChanges()" [disabled]="isLoading"
              style="background: #2563eb; color: #fff; font-weight: 600; padding: 0 20px; height: 38px; border-radius: 8px;">
              <mat-icon>send</mat-icon> Send Changes
            </button>
          </div>

          <div class="total-row">
            <div class="total-display">
              <span>Total Hours worked</span>
              <strong>{{ getTotalHours() | number: "1.2-2" }}</strong>
            </div>
          </div>

          <!-- Centered Agree to Timesheet Button for Customer -->
          <div *ngIf="isCustomer && !customerAgreed && !isCompleted && timesheetStatus === 'submitted'"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 24px; margin-bottom: 8px; gap: 12px; width: 100%;">
            <button mat-flat-button (click)="agreeToTimesheet()" [disabled]="isLoading || hasDisputedRows"
              style="background: #2563eb; color: #fff; font-weight: 600; padding: 0 28px; font-size: 15px; border-radius: 8px; height: 46px; display: inline-flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);">
              <mat-icon style="font-size: 20px; width: 20px; height: 20px;">thumb_up</mat-icon>
              Agree to Timesheet
            </button>
            <span *ngIf="hasDisputedRows"
              style="font-size: 12px; color: #f59e0b; display: flex; align-items: center; gap: 4px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px;">warning</mat-icon>
              Please resolve suggested corrections before agreeing.
            </span>
          </div>
        </div>
        <!-- End details-section -->
        <!-- Signature Section -->
        <div class="signature-section-wrapper" *ngIf="rows.length > 0" style="
            margin-top: 40px;
            border-top: 2px dashed #e2e8f0;
            padding-top: 30px;
          ">
          <div style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 12px;
              margin-bottom: 24px;
            ">
            <h3 style="margin: 0; font-weight: 600; color: #334155">
              Agreement &amp; Signatures
            </h3>

          </div>

          <!-- === SIGNATURE AREA === -->
          <!-- Completed State: Show both signatures -->
          <div *ngIf="isCompleted" style="
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 40px;
              margin-top: 20px;
            ">
            <!-- Customer Final Sig -->
            <div style="
                text-align: center;
                padding: 20px;
                border: 1px dashed #cbd5e1;
                border-radius: 8px;
              ">
              <h4 style="
                  margin: 0 0 16px;
                  color: #475569;
                  font-size: 13px;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                ">
                Customer Approval
              </h4>
              <img *ngIf="customerSignatureBase64 || customerSignatureUrl"
                [src]="customerSignatureBase64 || customerSignatureUrl" style="
                  max-height: 100px;
                  max-width: 100%;
                  display: block;
                  margin: 0 auto 12px;
                " />
              <div style="font-size: 12px; color: #0284c7; font-weight: 600">
                {{ customerName }} (Verified)
              </div>
            </div>

            <!-- Vendor Final Sig -->
            <div style="
                text-align: center;
                padding: 20px;
                border: 1px dashed #cbd5e1;
                border-radius: 8px;
              ">
              <h4 style="
                  margin: 0 0 16px;
                  color: #475569;
                  font-size: 13px;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                ">
                Vendor Certification
              </h4>
              <img *ngIf="vendorSignatureBase64 || vendorSignatureUrl"
                [src]="vendorSignatureBase64 || vendorSignatureUrl" style="
                  max-height: 100px;
                  max-width: 100%;
                  display: block;
                  margin: 0 auto 12px;
                " />
              <div style="font-size: 12px; color: #0284c7; font-weight: 600">
                {{ vendorName }} (Verified)
              </div>
            </div>
          </div>

          <!-- Interactive Signature Area (only when NOT completed) -->
          <div *ngIf="!isCompleted && timesheetStatus === 'submitted'" style="
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 32px;
              margin-top: 20px;
            ">
            <!-- Customer Signature (Left) -->
            <div style="
                border: 1px solid #e2e8f0;
                border-radius: 12px;
                padding: 24px;
                background: #f8fafc;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
              ">
              <h4 style="
                  margin-top: 0;
                  color: #1e293b;
                  text-align: center;
                  font-weight: 600;
                  border-bottom: 1px solid #e2e8f0;
                  padding-bottom: 12px;
                  margin-bottom: 20px;
                ">
                Customer Approval
              </h4>

              <!-- Already signed -->
              <div *ngIf="customerSignatureUrl || customerSignatureBase64" class="signature-display">
                <img [src]="customerSignatureBase64 || customerSignatureUrl" alt="Customer Signature" />
                <div class="verified-badge">
                  <mat-icon>verified</mat-icon>
                  Approved by Customer
                </div>
              </div>

              <!-- Customer's active signing pad -->
              <div *ngIf="isCustomer && customerAgreed && !customerSignatureUrl" style="text-align: center">
                <p style="color: #64748b; margin-bottom: 16px; font-size: 14px">
                  Sign here to approve these hours
                </p>
                <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="200ms" class="signature-tabs">
                  <mat-tab label="Digital Pad">
                    <div style="padding-top: 16px">
                      <canvas #sigCanvas width="350" height="120" (mousedown)="startDrawing($event)"
                        (mousemove)="draw($event)" (mouseup)="stopDrawing()" (mouseleave)="stopDrawing()" style="
                          border: 1px solid #cbd5e1;
                          background: white;
                          border-radius: 6px;
                          cursor: crosshair;
                          width: 100%;
                        "></canvas>
                      <div style="
                          margin-top: 12px;
                          display: flex;
                          gap: 12px;
                          justify-content: center;
                        ">
                        <button mat-button color="warn" (click)="clearCanvas()">
                          Clear
                        </button>
                        <button mat-raised-button color="primary" (click)="saveCanvasSignature()"
                          style="background: #2563eb">
                          Confirm
                        </button>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Upload Image">
                    <div style="padding: 24px; text-align: center">
                      <button mat-stroked-button color="primary" (click)="triggerSigInput()">
                        <mat-icon>upload</mat-icon> Choose File
                      </button>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>

              <!-- Customer hasn't agreed yet -->
              <div *ngIf="isCustomer && !customerAgreed && !(customerSignatureUrl || customerSignatureBase64)"
                style="text-align: center; padding: 30px; color: #64748b;">
                <mat-icon
                  style="font-size: 40px; height: 40px; width: 40px; color: #94a3b8; margin-bottom: 8px;">lock</mat-icon>
                <p style="font-size: 13px; margin: 0;">Please click <strong>"Agree to Timesheet"</strong> above to
                  unlock the signature pad.</p>
              </div>

              <!-- Vendor viewing and customer has not signed yet -->
              <div *ngIf="!isCustomer && !(customerSignatureUrl || customerSignatureBase64)"
                style="text-align: center; padding: 40px; color: #94a3b8">
                <mat-icon style="
                    font-size: 48px;
                    height: 48px;
                    width: 48px;
                    opacity: 0.3;
                  ">hourglass_empty</mat-icon>
                <p style="margin-top: 12px">Awaiting Customer Agreement &amp; Signature</p>
              </div>
            </div>

            <!-- Vendor Signature (Right) -->
            <div style="
                border: 1px solid #e2e8f0;
                border-radius: 12px;
                padding: 24px;
                background: #f8fafc;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
              ">
              <h4 style="
                  margin-top: 0;
                  color: #1e293b;
                  text-align: center;
                  font-weight: 600;
                  border-bottom: 1px solid #e2e8f0;
                  padding-bottom: 12px;
                  margin-bottom: 20px;
                ">
                Vendor Certification
              </h4>

              <!-- Already signed -->
              <div *ngIf="vendorSignatureUrl || vendorSignatureBase64" class="signature-display">
                <img [src]="vendorSignatureBase64 || vendorSignatureUrl" alt="Vendor Signature" />
                <div class="verified-badge">
                  <mat-icon>verified</mat-icon>
                  Certified by Vendor
                </div>
              </div>

              <!-- Vendor's active signing pad (only after customer has signed) -->
              <div *ngIf="isVendor && canSign" style="text-align: center">
                <p style="color: #64748b; margin-bottom: 16px; font-size: 14px">
                  Sign here to certify these hours
                </p>
                <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="200ms" class="signature-tabs">
                  <mat-tab label="Digital Pad">
                    <div style="padding-top: 16px">
                      <canvas #sigCanvas width="350" height="120" (mousedown)="startDrawing($event)"
                        (mousemove)="draw($event)" (mouseup)="stopDrawing()" (mouseleave)="stopDrawing()" style="
                          border: 1px solid #cbd5e1;
                          background: white;
                          border-radius: 6px;
                          cursor: crosshair;
                          width: 100%;
                        "></canvas>
                      <div style="
                          margin-top: 12px;
                          display: flex;
                          gap: 12px;
                          justify-content: center;
                        ">
                        <button mat-button color="warn" (click)="clearCanvas()">
                          Clear
                        </button>
                        <button mat-raised-button color="primary" (click)="saveCanvasSignature()"
                          style="background: #0ea5e9">
                          Confirm
                        </button>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Upload Image">
                    <div style="padding: 24px; text-align: center">
                      <button mat-stroked-button color="primary" (click)="triggerSigInput()">
                        <mat-icon>upload</mat-icon> Choose File
                      </button>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>

              <!-- Waiting for customer to sign first (vendor viewing own slot before customer signs) -->
              <div *ngIf="isVendor && !canSign && !(vendorSignatureUrl || vendorSignatureBase64)"
                style="text-align: center; padding: 20px; color: #64748b">
                <mat-icon style="
                    font-size: 32px;
                    height: 32px;
                    width: 32px;
                    opacity: 0.5;
                  ">hourglass_top</mat-icon>
                <p style="font-size: 13px; margin-top: 8px">
                  {{ customerSignatureUrl ? 'Please sign to finalize.' : 'Waiting for Customer to sign first.' }}
                </p>
              </div>

              <!-- Not the vendor's turn yet (customer viewing vendor slot) -->
              <div *ngIf="!isVendor && !(vendorSignatureUrl || vendorSignatureBase64)"
                style="text-align: center; padding: 40px; color: #94a3b8">
                <mat-icon style="
                    font-size: 48px;
                    height: 48px;
                    width: 48px;
                    opacity: 0.3;
                  ">hourglass_empty</mat-icon>
                <p style="margin-top: 12px">Awaiting Vendor Certification</p>
              </div>
            </div>
          </div>

          <!-- Completion Final Message -->
          <div *ngIf="isCompleted" class="completion-message">
            <div class="check-icon">
              <mat-icon>task_alt</mat-icon>
            </div>
            <h3>Timesheet Fully Verified</h3>
            <p>Both parties have approved and signed this document.</p>
          </div>
        </div>
        <!-- End signature-section-wrapper -->
      </div>
      <!-- End lpo-paper -->
    </div>
    <!-- End lpo-scroll-area -->
    <div class="lpo-history-sidebar" [class.collapsed]="isHistoryCollapsed"
      *ngIf="fullHistory.length > 0 && !uploadedTimesheetUrl">
      <div class="sidebar-header" (click)="isHistoryCollapsed = !isHistoryCollapsed">
        <h3>
          <mat-icon>history</mat-icon>
          <span *ngIf="!isHistoryCollapsed">Event History</span>
        </h3>
        <button mat-icon-button class="collapse-btn">
          <mat-icon>{{
            isHistoryCollapsed
            ? "keyboard_double_arrow_left"
            : "keyboard_double_arrow_right"
            }}</mat-icon>
        </button>
      </div>
      <div class="sidebar-content" *ngIf="!isHistoryCollapsed">
        <div class="history-section overall-history">
          <div class="history-list">
            <div class="history-item" *ngFor="let log of fullHistory">
              <div class="history-meta">
                <span class="user">
                  {{ log.user }}
                  <span class="role" [ngClass]="log.role">{{ log.role }}</span>
                  <span class="history-row-date" *ngIf="log.rowDate" style="
                      margin-top: 4px;
                      font-weight: 500;
                      font-size: 10px;
                      color: #3b82f6;
                    ">
                    Date: {{ log.rowDate }}
                  </span>
                </span>
                <span class="time">{{
                  log.timestamp | date: "shortTime"
                  }}</span>
              </div>
              <div class="history-content">
                <span class="history-action">{{ log.action }}: </span>
                <span class="history-details">{{ log.details }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End lpo-dialog-container -->

  <!-- ── Updated Timesheet Modal ── -->
  <ng-template #acceptCorrectionModal>
    <div style="display: flex; flex-direction: column; height: 100%; font-family: 'Inter', sans-serif;">

      <!-- Header -->
      <div style="padding: 24px 28px 18px; border-bottom: 1px solid #e2e8f0;">
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 4px;">
          <span
            style="width: 32px; height: 32px; border-radius: 8px; background: #f0f9ff; display: flex; align-items: center; justify-content: center;">
            <mat-icon
              style="color: #0ea5e9; font-size: 20px; width: 20px; height: 20px;">assignment_turned_in</mat-icon>
          </span>
          <h3 style="margin: 0; font-size: 17px; font-weight: 700; color: #0f172a; letter-spacing: -0.3px;">Updated
            Timesheet</h3>
        </div>
        <p style="margin: 0; font-size: 13px; color: #64748b; line-height: 1.5; padding-left: 42px;">
          The row highlighted in green shows the customer's suggested update.
        </p>
      </div>

      <!-- Table -->
      <div style="flex: 1; overflow-y: auto; padding: 0;">
        <!-- Column Headers -->
        <div
          style="display: grid; grid-template-columns: 1.4fr 1fr 1fr 0.8fr 0.8fr; padding: 10px 28px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; position: sticky; top: 0; z-index: 1;">
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Date</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Start</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">End</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Break</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Total</span>
        </div>

        <!-- Data Rows -->
        <ng-container *ngFor="let row of rows; let i = index">
          <div [style.background]="row === activeReviewRow ? '#f0f9ff' : (i % 2 === 0 ? '#ffffff' : '#fafafa')"
            [style.border-left]="row === activeReviewRow ? '3px solid #0ea5e9' : '3px solid transparent'"
            style="display: grid; grid-template-columns: 1.4fr 1fr 1fr 0.8fr 0.8fr; padding: 12px 28px 12px 25px; border-bottom: 1px solid #f1f5f9; align-items: center;">
            <span style="font-size: 13px; font-weight: 600; color: #0f172a;">{{ row.date }}</span>
            <span style="font-size: 13px; color: #475569;">
              {{ formatTo12Hr((row === activeReviewRow && row.correctionStartTime ? row.correctionStartTime :
              row.startTime) || '') }}
            </span>
            <span style="font-size: 13px; color: #475569;">
              {{ formatTo12Hr((row === activeReviewRow && row.correctionEndTime ? row.correctionEndTime : row.endTime)
              || '') }}
            </span>
            <span style="font-size: 13px; color: #475569;">
              {{ (row === activeReviewRow && row.correctionBreakHours !== undefined ? row.correctionBreakHours :
              row.breakHours) }}h
            </span>
            <span style="font-size: 13px; color: #475569;">
              {{ (row === activeReviewRow && row.correctionTotalHours !== undefined ? row.correctionTotalHours :
              row.totalHours) | number:'1.1-1' }}h
            </span>
          </div>
        </ng-container>
      </div>

      <!-- Footer -->
      <div
        style="padding: 16px 28px; border-top: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: space-between; background: #fafafa;">
        <div style="display: flex; align-items: center; gap: 6px; font-size: 12px; color: #64748b;">
          <span
            style="width: 10px; height: 10px; border-radius: 2px; background: #bae6fd; border-left: 3px solid #0ea5e9; display: inline-block;"></span>
          Blue row — customer's suggested change
        </div>
        <div style="display: flex; gap: 10px; align-items: center;">
          <button mat-button mat-dialog-close style="color: #64748b; font-size: 13px; font-weight: 500;">Cancel</button>
          <button mat-flat-button (click)="confirmAcceptCorrection()"
            style="background: #0ea5e9; color: #fff; font-size: 13px; font-weight: 600; border-radius: 6px; padding: 0 20px; height: 36px; letter-spacing: 0.01em;">
            Accept Changes &amp; Send to Customer
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- ── Keep Original Modal ── -->
  <ng-template #keepOriginalModal>
    <div style="display: flex; flex-direction: column; height: 100%; font-family: 'Inter', sans-serif;">

      <!-- Header -->
      <div style="padding: 24px 28px 18px; border-bottom: 1px solid #e2e8f0;">
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 4px;">
          <span
            style="width: 32px; height: 32px; border-radius: 8px; background: #eff6ff; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="color: #3b82f6; font-size: 20px; width: 20px; height: 20px;">history</mat-icon>
          </span>
          <h3 style="margin: 0; font-size: 17px; font-weight: 700; color: #0f172a; letter-spacing: -0.3px;">Original
            Timesheet</h3>
        </div>
        <p style="margin: 0; font-size: 13px; color: #64748b; line-height: 1.5; padding-left: 42px;">
          The highlighted row is your original submitted entry. Confirming keeps this and discards the customer's
          suggestion.
        </p>
      </div>

      <!-- Table -->
      <div style="flex: 1; overflow-y: auto; padding: 0;">
        <!-- Column Headers -->
        <div
          style="display: grid; grid-template-columns: 1.4fr 1fr 1fr 0.8fr 0.8fr; padding: 10px 28px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; position: sticky; top: 0; z-index: 1;">
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Date</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Start</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">End</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Break</span>
          <span
            style="font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em;">Total</span>
        </div>

        <!-- Data Rows -->
        <ng-container *ngFor="let row of rows; let i = index">
          <div [style.background]="row === activeReviewRow ? '#eff6ff' : (i % 2 === 0 ? '#ffffff' : '#fafafa')"
            [style.border-left]="row === activeReviewRow ? '3px solid #3b82f6' : '3px solid transparent'"
            style="display: grid; grid-template-columns: 1.4fr 1fr 1fr 0.8fr 0.8fr; padding: 12px 28px 12px 25px; border-bottom: 1px solid #f1f5f9; align-items: center;">
            <span style="font-size: 13px; font-weight: 600; color: #0f172a;">{{ row.date }}</span>
            <span style="font-size: 13px; color: #475569;">{{ formatTo12Hr(row.startTime || '') }}</span>
            <span style="font-size: 13px; color: #475569;">{{ formatTo12Hr(row.endTime || '') }}</span>
            <span style="font-size: 13px; color: #475569;">{{ row.breakHours }}h</span>
            <span style="font-size: 13px; color: #475569;">{{ row.totalHours | number:'1.1-1' }}h</span>
          </div>
        </ng-container>
      </div>

      <!-- Footer -->
      <div
        style="padding: 16px 28px; border-top: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: space-between; background: #fafafa;">
        <div style="display: flex; flex-direction: column; gap: 2px;">
          <div style="display: flex; align-items: center; gap: 6px; font-size: 12px; color: #64748b;">
            <span
              style="width: 10px; height: 10px; border-radius: 2px; background: #dbeafe; border-left: 3px solid #3b82f6; display: inline-block;"></span>
            Blue row — entry under review
          </div>
          <span style="font-size: 11px; color: #f59e0b; display: flex; align-items: center; gap: 4px;">
            <mat-icon style="font-size: 12px; width: 12px; height: 12px;">info</mat-icon>
            Changes rejected — customer will be notified
          </span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center;">
          <button mat-button mat-dialog-close style="color: #64748b; font-size: 13px; font-weight: 500;">Cancel</button>
          <button mat-flat-button (click)="confirmKeepOriginal()"
            style="background: #3b82f6; color: #fff; font-size: 13px; font-weight: 600; border-radius: 6px; padding: 0 20px; height: 36px; letter-spacing: 0.01em;">
            Keep Original &amp; Send to Customer
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Hidden Input for Signature Upload -->
  <input type="file" id="tsSigInput" (change)="onSigSelected($event)" accept="image/*" hidden />
</div>